import { ArrowRight, CheckCircle2, LockKeyhole, Sparkles } from "lucide-react";

interface HeroSectionProps {
  betaJoined: boolean;
  onBetaJoin: (email: string) => void;
}

export function HeroSection({ betaJoined, onBetaJoin }: HeroSectionProps) {
  return (
    <section className="hero-section" id="top" aria-labelledby="hero-title">
      <div className="hero-copy">
        <h1 id="hero-title">Safe screen time that actually teaches.</h1>
        <p>
          Reading and maths for ages 3 to 13, designed to sit inside the Nesty family experience you already use.
        </p>
        <form
          className="beta-form"
          id="join-beta"
          onSubmit={(event) => {
            event.preventDefault();
            const form = new FormData(event.currentTarget);
            const email = String(form.get("email") ?? "").trim();
            if (email) onBetaJoin(email);
          }}
        >
          <label className="visually-hidden" htmlFor="email">
            Parent email
          </label>
          <input id="email" name="email" type="email" placeholder="Parent email" required />
          <button className="primary-button" type="submit">
            Join free beta
            <ArrowRight size={18} aria-hidden="true" />
          </button>
        </form>
        <p className="form-result" aria-live="polite">
          {betaJoined ? "You are on the beta list. We saved this locally for the demo build." : "Free core learning path. No ads. No open chat."}
        </p>
        <div className="hero-proof" aria-label="Product principles">
          <span>
            <CheckCircle2 size={18} aria-hidden="true" /> Structured reading
          </span>
          <span>
            <Sparkles size={18} aria-hidden="true" /> Concept-first maths
          </span>
          <span>
            <LockKeyhole size={18} aria-hidden="true" /> Parent-led safety
          </span>
        </div>
      </div>
      <div className="hero-art" aria-label="A calm family learning scene">
        <img src="/nesty-hero-learning.png" alt="" />
      </div>
    </section>
  );
}
